var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7511_66109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.05273 6.3501L4.71681 8.56316L5.04885 9.66969M12.3287 16.9511L13.4357 17.2831L15.6498 17.9472",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 10.9999L11.5446 10.4554L13.0443 8.95559L16.0439 5.95605",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.998047 4.33288C0.998047 4.60647 1.05193 4.87739 1.15663 5.13015C1.26133 5.38292 1.41479 5.61259 1.60825 5.80605C1.80171 5.99951 2.03138 6.15297 2.28415 6.25767C2.53691 6.36236 2.80783 6.41625 3.08142 6.41625C3.35501 6.41625 3.62592 6.36236 3.87869 6.25767C4.13145 6.15297 4.36112 5.99951 4.55458 5.80605C4.74804 5.61259 4.9015 5.38292 5.0062 5.13015C5.1109 4.87739 5.16479 4.60647 5.16479 4.33288C5.16479 4.05929 5.1109 3.78838 5.0062 3.53561C4.9015 3.28284 4.74804 3.05318 4.55458 2.85972C4.36112 2.66626 4.13145 2.5128 3.87869 2.4081C3.62592 2.3034 3.35501 2.24951 3.08142 2.24951C2.80783 2.24951 2.53691 2.3034 2.28415 2.4081C2.03138 2.5128 1.80171 2.66626 1.60825 2.85972C1.41479 3.05318 1.26133 3.28284 1.15663 3.53561C1.05193 3.78838 0.998047 4.05929 0.998047 4.33288Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.584 3.70838C15.584 4.42669 15.8693 5.11558 16.3773 5.6235C16.8852 6.13142 17.5741 6.41677 18.2924 6.41677C19.0107 6.41677 19.6996 6.13142 20.2075 5.6235C20.7154 5.11558 21.0007 4.42669 21.0007 3.70838C21.0007 2.99007 20.7154 2.30119 20.2075 1.79327C19.6996 1.28535 19.0107 1 18.2924 1C17.5741 1 16.8852 1.28535 16.3773 1.79327C15.8693 2.30119 15.584 2.99007 15.584 3.70838Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.584 18.9169C15.584 19.4694 15.8035 19.9993 16.1942 20.39C16.5849 20.7807 17.1148 21.0002 17.6674 21.0002C18.2199 21.0002 18.7498 20.7807 19.1405 20.39C19.5312 19.9993 19.7507 19.4694 19.7507 18.9169C19.7507 18.3643 19.5312 17.8344 19.1405 17.4437C18.7498 17.053 18.2199 16.8335 17.6674 16.8335C17.1148 16.8335 16.5849 17.053 16.1942 17.4437C15.8035 17.8344 15.584 18.3643 15.584 18.9169Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.998047 15.2711C0.998047 16.7906 1.60167 18.2479 2.67613 19.3223C3.75059 20.3968 5.20786 21.0004 6.72737 21.0004C8.24689 21.0004 9.70416 20.3968 10.7786 19.3223C11.8531 18.2479 12.4567 16.7906 12.4567 15.2711C12.4567 13.7516 11.8531 12.2943 10.7786 11.2198C9.70416 10.1454 8.24689 9.54175 6.72737 9.54175C5.20786 9.54175 3.75059 10.1454 2.67613 11.2198C1.60167 12.2943 0.998047 13.7516 0.998047 15.2711Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7511_66109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/Community.a80c126e120851a342c6c7c91dc4c940.svg";
export { ForwardRef as ReactComponent };